import { useEffect, useRef } from 'react';

function getClientContext() {
  let timezone = 'unknown';
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || timezone;
  } catch (_) {
    // Browser diagnostics are best-effort and must never hide the UI error.
  }

  return {
    language: navigator.language || 'unknown',
    online: Boolean(navigator.onLine),
    timestamp: new Date().toISOString(),
    timezone,
    url: window.location.href,
    viewport: {
      height: window.innerHeight,
      pixelRatio: window.devicePixelRatio,
      width: window.innerWidth,
    },
  };
}

function reportUiError(message, context, details) {
  if (typeof fetch !== 'function') return;

  void fetch('/api/client-errors', {
    body: JSON.stringify({
      client: getClientContext(),
      context,
      details,
      message,
      path: window.location.pathname,
    }),
    headers: { 'Content-Type': 'application/json' },
    keepalive: true,
    method: 'POST',
  }).catch(() => undefined);
}

export default function UiError({ as: Element = 'p', children, context, details, ...props }) {
  const lastReportedError = useRef(null);

  useEffect(() => {
    const reportKey = `${context}\n${String(children)}\n${JSON.stringify(details)}`;
    if (lastReportedError.current === reportKey) return;
    lastReportedError.current = reportKey;
    reportUiError(String(children), context, details);
  }, [children, context, details]);

  return <Element role="alert" {...props}>{children}</Element>;
}
